function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const urls = {
  site: '/sites/planning',
  tc: '/routecontrols/planning'
};

const filterNames = {
  site: 'siteplanning',
  tc: 'tcplanning'
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  overviewTitle: 'Planning',
  detailTitle: 'Planning',
  deleteTitle: 'deze planning',
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/sitereportlayouts/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName(context) {
    return filterNames[getType(context)];
  },
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  newRecord: {
    report_layout_type: 2
  },
  tableFields(context) {
    return [
      {
        text: 'Naam',
        value: 'name',
        link: urls[getType(context)] + '/{id}',
        width: '30%'
      },
      {
        text: 'Bestandsnaam',
        value: 'file.name',
        width: '30%'
      },
      {
        text: 'Grootte',
        value: 'file.size',
        width: '20%',
        filter: 'prettyBytes'
      }
    ];
  }
};
